import 'styled-components';

import {
  BlueSkyColors,
  GreyWarmColors,
  PrimaryColors,
  SecondaryColors,
} from './color';

import dark from './dark';
import light from './light';
export type Radius = { '3px': '3px'; '6px': '6px'; '9px': '9px' };
export type Spacing = {
  '2px': '2px';
  '4px': '4px';
  '8px': '8px';
  '16px': '16px';
  '32px': '32px';
};

export type Theme = typeof light;

// Add Theme type to styled-components
declare module 'styled-components' {
  export interface DefaultTheme {
    mode: string;
    colors: {
      white: string;
      lightestGray: string;
      lightGrey: string;
      textGrey: string;
      grey: string;
      midGrey: string;
      darkGrey: string;
      linearGradient: string;
      lightBlue: string;
      midBlue: string;
      darkBlue: string;
      green: string;
      orange: string;
      red: string;
      secondary: SecondaryColors;
      primary: PrimaryColors;
      greyWarm: GreyWarmColors;
      blueSky: BlueSkyColors;
      text: {
        primary: string;
        secondary: string;
      };
      outline: {
        primary: string;
      };
    };
    typography: {
      primary: {
        regular: string;
        bold: string;
      };
    };
    spacing: Spacing;
    radius: Radius;
  }
}

export const themes = {
  dark,
  light,
};

export default themes;
